module.exports = __webpack_public_path__ + "static/img/add-per-bg.cf9b1201.png";